import { useMemo } from "react"
import { useQuery } from "@tanstack/react-query"
import BasePage from "../../components/layout/BasePage"
import BaseSecondaryHero from "../../components/layout/BaseSecondaryHero"
import ProjectGridSection from "../../components/common/ProjectGridSection"
import ContactCTA from "../../components/common/ContactCTA"
import Loading from "../../components/common/Loading"
import Customers from "../Homepage/components/Customers"
import { getPortfolio, getPortfolioPage } from "./api/apiCalls"

export type ItemData = {
    screenshot: any
    headline: string
    subheadline: string
    id: number
    hasDetailPage: boolean
}

export default function Portfolio() {
    const { data: page, isLoading: pageLoading } = useQuery({
        queryKey: ["portfolioPage"],
        queryFn: getPortfolioPage,
    })

    const { data: projectsData, isLoading: projectsLoading } = useQuery({
        queryKey: ["projects"],
        queryFn: getPortfolio,
    })

    const projects = useMemo(() => {
        if (!projectsData) {
            return []
        }

        return projectsData.map((item: any) => {
            const source = item?.attributes?.preview ?? item?.attributes

            return {
                ...source,
                label: source?.label ?? item?.attributes?.subheadline,
                sublabel: source?.sublabel ?? item?.attributes?.headline,
                id: item.id,
                previewImage: item.attributes.previewImage,
                screenshot: item.attributes.screenshot,
                hasDetailPage: item.attributes.hasDetailPage ?? source?.hasDetailPage,
            }
        })
    }, [projectsData])

    if (pageLoading || projectsLoading || !page) {
        return <Loading />
    }

    return (
        <BasePage>
            <BaseSecondaryHero heading={page.hero} />
            <ProjectGridSection projects={projects} />
            <Customers logos={page.customers?.logos} heading={page.customers?.heading} />
            <ContactCTA />
        </BasePage>
    )
}
